module.exports = __webpack_public_path__ + "static/media/faq-arrow2.99be9aa3.svg";